/** @format */

import {useCallback, useLayoutEffect, useState} from 'react';

import {useMediaQuery} from '@mui/material';

import theme from 'theme';

import {FIXED_HEIGHTS} from '../constants';

interface UseDynamicTableHeightProps {
  filterBarRef: React.RefObject<HTMLDivElement>;
  periodSelectorRef: React.RefObject<HTMLDivElement>;
}

export const useDynamicTableHeight = ({
  filterBarRef,
  periodSelectorRef,
}: UseDynamicTableHeightProps) => {
  const [tableHeight, setTableHeight] = useState<number>(0);

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const calculateTableHeight = useCallback(() => {
    const windowHeight = window.innerHeight;

    if (isMobile) {
      setTableHeight(windowHeight);
      return;
    }

    // Получаем реальную высоту FilterBar или используем fallback
    const filterBarHeight = filterBarRef.current?.offsetHeight || FIXED_HEIGHTS.FILTER_BAR_FALLBACK;
    const periodSelectorHeight =
      periodSelectorRef.current?.offsetHeight || FIXED_HEIGHTS.PERIOD_SELECTOR_FALLBACK;
    const totalAboveTableHeight =
      FIXED_HEIGHTS.APP_HEADER +
      FIXED_HEIGHTS.BREADCRUMBS +
      FIXED_HEIGHTS.SCROLL_HEIGHT +
      periodSelectorHeight +
      filterBarHeight;

    const availableHeight = windowHeight - totalAboveTableHeight;
    const calculatedHeight = Math.max(FIXED_HEIGHTS.MIN_TABLE_HEIGHT, availableHeight);

    setTableHeight(calculatedHeight);
  }, [filterBarRef, isMobile, periodSelectorRef]);

  useLayoutEffect(() => {
    calculateTableHeight();

    window.addEventListener('resize', calculateTableHeight);

    return () => {
      window.removeEventListener('resize', calculateTableHeight);
    };
  }, [calculateTableHeight]);

  useLayoutEffect(() => {
    if (filterBarRef.current) {
      calculateTableHeight();
    }
  }, [calculateTableHeight, filterBarRef]);

  return tableHeight;
};
